import { PropsWithoutRef, Suspense } from 'react';

// project import
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable =
    (Component: React.LazyExoticComponent<() => React.JSX.Element>) =>
    (props: PropsWithoutRef<any>) => (
        <Suspense fallback={<Loader />}>
            <Component {...props} />
        </Suspense>
    );

export default Loadable;
